import React from "react";

import Routes from "./routes";
// @ts-ignore
import { GlobalStyles } from "./styles/globalStyled";
import muiTheme from "./styles/muiTheme";
import Theme from "./styles/theme";
// import { blueTheme } from "@joinlearn/package";
//import { store, persistor } from "./store";
//import { PersistGate } from "redux-persist/integration/react";
//import { Provider } from "react-redux";

// @ts-ignore
import TagManager from "react-gtm-module";
import { ThemeProvider } from "styled-components";
import { StyledEngineProvider, ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { AuthProvider } from "./context/user/AuthContext";
//

const tagManagerArgs = {
    gtmId: "GTM-WZTQ88G",
};

TagManager.initialize(tagManagerArgs);

export default function App() {
    return (
        ///<Provider store={store}>
        //<PersistGate loading={null} persistor={persistor}>
        <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={muiTheme}>
                <ThemeProvider theme={Theme}>
                    <GlobalStyles />
                    <AuthProvider>
                        <Routes />
                    </AuthProvider>
                </ThemeProvider>
            </MuiThemeProvider>
        </StyledEngineProvider>
        //</PersistGate>
        //</Provider>
    );
}
